import { ReactElement, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import dots from "../../assets/images/newsFeeds/dots.png";
import "../../assets/css/newsFeeds.css";
import { useDynamicPageMeta } from "../../hooks/useDynamicPageMeta";
import { getNewsFeed, NewsFeedItem } from "../../Services/NewsFeeds";
import NewsFeedsAccordion from "./components/NewsFeedsAccordion";
import NewsFeedsBanner from "./components/NewsFeedsBanner";
import NewsFeedsStories from "./components/NewsFeedsStories";

const DEFAULT_LOOKUP = "world_top";

export default function NewsFeedsPage(): ReactElement {
  const [params, setSearchParams] = useSearchParams();
  const { setPageMeta, clearPageMeta } = useDynamicPageMeta();
  const lookup = (params.get("feedlookup") || DEFAULT_LOOKUP).trim().toLowerCase();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [items, setItems] = useState<NewsFeedItem[]>([]);
  const [unavailable, setUnavailable] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "World News - World Services Group";
    setPageMeta({
      breadcrumbLabels: { "/news-feeds": "World News" },
    });
    return () => {
      clearPageMeta();
    };
  }, [clearPageMeta, setPageMeta]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getNewsFeed(lookup)
      .then((payload) => {
        if (!cancelled) {
          setItems(payload.items || []);
          setUnavailable(Boolean(payload.unavailable));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setUnavailable(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [lookup]);

  function chooseFeed(nextLookup: string): void {
    const query = new URLSearchParams(params);
    if (nextLookup === DEFAULT_LOOKUP) {
      query.delete("feedlookup");
    } else {
      query.set("feedlookup", nextLookup);
    }
    setSearchParams(query);
  }

  function togglePane(index: number): void {
    setOpenIndex((current) => (current === index ? null : index));
  }

  return (
    <div className="news-feeds-page">
      <div className="news-feeds-hero" aria-hidden="true" />
      <NewsFeedsBanner />
      <section className="news-feeds-sheet">
        <div className="news-feeds-columns">
          <NewsFeedsStories loading={loading} unavailable={unavailable} items={items} />
          <NewsFeedsAccordion openIndex={openIndex} onToggle={togglePane} onChoose={chooseFeed} />
        </div>
        <img className="news-feeds-dots" src={dots} alt="dots" />
      </section>
    </div>
  );
}
